import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class NoticeContentService {
    private readonly noticeContentSubject = new BehaviorSubject<string>(''); // private subject
    private readonly maxFileSizeSubject = new BehaviorSubject<number>(100); // default 100MB
    private readonly maxTimeConfigsSubject = new BehaviorSubject<number>(1); // default 1

    noticeContent$: Observable<string> = this.noticeContentSubject.asObservable();
    maxFileSize$: Observable<number> = this.maxFileSizeSubject.asObservable();
    maxTimeConfigs$: Observable<number> = this.maxTimeConfigsSubject.asObservable();

    constructor() {}

    updateContent(content: string): void {
        this.noticeContentSubject.next(content);
    }

    updateMaxFileSize(size: number): void {
        this.maxFileSizeSubject.next(size);
    }

    updateMaxTimeConfigs(max: number): void {
        this.maxTimeConfigsSubject.next(max);
    }

    getContent(): Observable<string> {
        return this.noticeContent$;
    }

    getCurrentMaxFileSize(): number {
        return this.maxFileSizeSubject.value;
    }

    getCurrentMaxTimeConfigs(): number {
        return this.maxTimeConfigsSubject.value;
    }
}
